import { inject, provide } from 'vue';
import type { Component } from 'vue';
import type { BannerId } from '../types';

export type BannerRegistry = Partial<Record<BannerId, Component>>;

const BANNER_REGISTRY_KEY = Symbol('serpBannerRegistry');

export function provideBannerRegistry(registry: BannerRegistry): void {
    provide(BANNER_REGISTRY_KEY, registry);
}

export function injectBannerRegistry(): BannerRegistry {
    return inject(BANNER_REGISTRY_KEY, {});
}
